import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

// npm imports
import { CKEditorModule } from "ckeditor4-angular";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgxPaginationModule } from "ngx-pagination";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatStepperModule } from "@angular/material/stepper";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FullCalendarModule } from "@fullcalendar/angular";
import { ToastModule } from "primeng/toast";
import { MatSelectModule } from "@angular/material/select";
import { InputSwitchModule } from "primeng/inputswitch";
import { MultiSelectModule } from "primeng/multiselect";
import { SelectButtonModule } from "primeng/selectbutton";
import { MenuModule } from "primeng/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { CalendarModule } from "primeng/calendar";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { DropdownModule } from "primeng/dropdown";
import { AccordionModule } from "primeng/accordion";
import { PanelModule } from "primeng/panel";
import { AvatarModule } from "ngx-avatar";
import { ChartModule } from "primeng/chart";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin
import interactionPlugin from "@fullcalendar/interaction";
import { SpinnerComponent } from "./spinner/spinner.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { ToastMessageComponent } from "./toast-message/toast-message.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { CustomNotificationComponent } from "./custom-notification/custom-notification.component";
import { MatBadgeModule } from "@angular/material/badge";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { ChartsModule } from "ng2-charts";
import { DragAndDropDirective } from "../Directives/drag-and-drop.directive";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { PatientDetailsComponent } from "./patient-details/patient-details.component";
import { AddEditFamilyMembersComponent } from "./add-edit-family-members/add-edit-family-members.component";
import { PatientAddressDetailsComponent } from "./patient-address-details/patient-address-details.component";
import { TieredMenuModule } from "primeng/tieredmenu";
import {DragDropModule} from '@angular/cdk/drag-drop';
import { LyTheme2, StyleRenderer, LY_THEME_NAME, LY_THEME_GLOBAL_VARIABLES, LyHammerGestureConfig } from "@alyle/ui";
import { LyImageCropperModule } from "@alyle/ui/image-cropper";
import { LySliderModule } from "@alyle/ui/slider";
import { HAMMER_GESTURE_CONFIG } from "@angular/platform-browser";

import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { SharedMethodsComponent } from "./shared-methods/shared-methods.component";
import { color } from "@alyle/ui/color";
import { CheckboxModule, SplitButtonModule, EditorModule } from "primeng";
import {MatMenuModule} from '@angular/material/menu';
import {MatTreeModule} from '@angular/material/tree';
import { VirtualScrollerModule } from "ngx-virtual-scroller";
import { EmailEditorModule } from "angular-email-editor";
// import { NgxEditorModule } from 'ngx-editor';
import { NgxSummernoteModule } from 'ngx-summernote';

export class GlobalVariables {
  testVal = color(0x00bcd4);
  Quepal = {
    default: `linear-gradient(135deg,#11998e 0%,#38ef7d 100%)`,
    contrast: color(0xffffff),
    shadow: color(0x11998e)
  };
  SublimeLight = {
    default: `linear-gradient(135deg,#FC5C7D 0%,#6A82FB 100%)`,
    contrast: color(0xffffff),
    shadow: color(0xB36FBC)
  };
  Amber = {
    default: color(0xffc107),
    contrast: color(0, 0, 0, 0.87)
  };
}

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  listPlugin,
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin,
]);
@NgModule({
  declarations: [
    SpinnerComponent,
    ToastMessageComponent,
    CustomNotificationComponent,
    DragAndDropDirective,
    PatientDetailsComponent,
    AddEditFamilyMembersComponent,
    PatientAddressDetailsComponent,
    SharedMethodsComponent,
  ],
  imports: [
    CommonModule,
    ToastModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    ButtonModule,
    MatTooltipModule
  ],
  exports: [
    MatSnackBarModule,
    ToastMessageComponent,
    DragAndDropDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxDatatableModule,
    CKEditorModule,
    NgxPaginationModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FullCalendarModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    ToastModule,
    MatSelectModule,
    InputSwitchModule,
    MultiSelectModule,
    MatSlideToggleModule,
    SelectButtonModule,
    MatCheckboxModule,
    MenuModule,
    CalendarModule,
    BreadcrumbModule,
    DropdownModule,
    AccordionModule,
    PanelModule,
    AvatarModule,
    ChartModule,
    SpinnerComponent,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    DialogModule,
    ButtonModule,
    TableModule,
    MatBadgeModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatExpansionModule,
    MatTooltipModule,
    MatListModule,
    MatProgressBarModule,
    ChartsModule,
    InputTextModule,
    InputTextareaModule,
    PatientDetailsComponent,
    AddEditFamilyMembersComponent,
    PatientAddressDetailsComponent,
    TieredMenuModule,
    DragDropModule,
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    CheckboxModule,
    SplitButtonModule,
    MatMenuModule,
    EditorModule,
    MatTreeModule,
    VirtualScrollerModule,
    EmailEditorModule,
    NgxSummernoteModule
    // NgxEditorModule
  ],
  providers:[
    DatePipe,
    [ LyTheme2 ],
    [ StyleRenderer ],
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    {
      provide: LY_THEME_GLOBAL_VARIABLES,
      useClass: GlobalVariables
    }, // global variables
    // Gestures
    { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig }
  ]
})
export class SharedModule {}
